<template>
  <div class="d-flex flex-column justify-content-center">
    <div :class="['card-wrapper', cardClass]" />
    <el-form id="cc-form" :model="creditCard" :rules="rules" ref="cardForm">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-input-title required>Card Number</el-input-title>
          <el-form-item class="mt-05" prop="number">
            <el-input name="number" v-model="creditCard.number" placeholder="4200 0000 0000 0000"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-input-title required>{{nationalId === 10 ? 'Name on Card': 'Full Name'}}</el-input-title>
          <el-form-item class="mt-05" prop="name">
            <el-input name="name" v-model="creditCard.name" placeholder="Eg. John Smith"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-input-title required>
            Expiry
            <small class="ml-05">
              <el-tooltip effect="dark" placement="top" content="Expiry date must be in the format MM/YY">
                <i class="el-icon-question" />
              </el-tooltip>
            </small>
          </el-input-title>
          <el-form-item class="mt-05" prop="expiry">
            <el-input name="expiry" v-model="creditCard.expiry" placeholder="MM/YY"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-input-title required>CVC</el-input-title>
          <el-form-item class="mt-05" prop="cvc">
            <el-input name="cvc" v-model="creditCard.cvc" placeholder="Eg: 123"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import * as Card from 'card';

const nameRule = [
  { required: true, message: 'Name is required', trigger: 'blur' },
  { pattern: /^([\u10A0-\u10FFa-zA-Z][\u10A0-\u10FFa-z'-]*\s+){1,}[\u10A0-\u10FFa-zA-Z][\u10A0-\u10FFa-z'-]*\s*$/i, message: 'Name must contain at least two words' }];
const cardNumberRule = [
  { required: true, message: 'Card number is required', trigger: 'blur' },
  { pattern: /^([0-9]{4}[\s-]?){3}([0-9]{3,4})$/, message: 'Please enter a valid card number', trigger: 'blur' }
];
const cvcCodeRule = [
  { required: true, message: 'CVC code is required', trigger: 'blur' },
  { pattern: /^\d{3,4}$/, message: 'CVC code must be a three or four-digit number', trigger: 'blur' }
];
// const expiryDateRule = [
//   { required: true, message: 'Expiry date is required', trigger: 'blur' },
//   { pattern: /^(0[1-9]|1[0-2]) \/ \d{2}$/, message: 'Expiry date must be in the format "MM/YY"', trigger: 'blur' }
//   // { pattern: /^(0[1-9]|1[0-2]) \/ ([0-9]{2})$/, message: 'Expiry date must be in the format "MM/YY"', trigger: 'blur' }
// ];

export default {
  name: 'CreditCard',
  props: {
    width: Number,
    cardClass: String
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      creditCard: {
        number: undefined,
        name: undefined,
        expiry: undefined,
        cvc: undefined
      },
      rules: {
        number: cardNumberRule,
        name: nameRule,
        // expiry: expiryDateRule,
        cvc: cvcCodeRule,
      }
    };
  },
  mounted() {
    console.log('nationalId', this.nationalId);
    // eslint-disable-next-line
    new Card({
      form: '#cc-form',
      container: '.card-wrapper',
      width: this.width,
      formatting: true,
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'FULL NAME',
        expiry: '••/••',
        cvc: '•••'
      }
    });
  },
  methods: {
    validate() {
      return this.$refs.cardForm.validate();
    }
  },
  watch: {
    creditCard: {
      handler() {
        this.$emit('input', this.creditCard);
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  // margin-right: -48px;
  // margin-left: -30px;
  // margin-top: -5px;
}
</style>
